/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareLetterM = createReactComponent("square-letter-m", "IconSquareLetterM", [
  [
    "path",
    {
      d: "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M9 16v-8l3 5l3 -5v8", key: "svg-1" }]
]);

export { IconSquareLetterM as default };
//# sourceMappingURL=IconSquareLetterM.js.map
